import { render, staticRenderFns } from "./SupsisNewLogo.vue?vue&type=template&id=d9fffcc6"
import script from "./SupsisNewLogo.vue?vue&type=script&lang=js"
export * from "./SupsisNewLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports